<div class="content">
    <div class="social" *ngIf="showButtons && copyUrl === ''">
        <div class="btn fb">
            <img src="./assets/img/icon-fb.svg" alt="icon-fb"/>
        </div>
        <div class="btn tw">
            <img src="./assets/img/icon-tw.svg" alt="icon-tw"/>
        </div>
        <div class="btn in">
            <img src="./assets/img/icon-in.svg" alt="icon-in"/>
        </div>
        <div class="btn wa">
            <img src="./assets/img/icon-wa.svg" alt="icon-wa"/>
        </div>
        <div class="btn cp">
            <img src="./assets/img/icon-cp.svg" alt="icon-cp"/>
        </div>
    </div>
    <share-buttons *ngIf="showDetails === true"
        [theme]="'default'"
        [include]="['facebook','twitter','linkedin','whatsapp','copy']"
        [show]="5"
        [url]="shareUrl"
        [title]="'Hola BitCar'"
        [description]="carTitle"
    ></share-buttons>
    <div class="arrows">
        <mat-icon *ngIf="!showButtons && !showDetails" (click)="generateLink()" class="mr-1">share</mat-icon>
        <mat-icon *ngIf="showButtons" (click)="showButtons = false; showDetails = false">arrow_back_ios</mat-icon>
    </div>
</div>
